<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.66893 6.45271C4.66893 5.46756 5.46756 4.66893 6.45272 4.66893H9.12839C10.1136 4.66893 10.9122 5.46756 10.9122 6.45271C10.9122 7.43787 10.1136 8.2365 9.12839 8.2365H6.45272C5.46756 8.2365 4.66893 7.43787 4.66893 6.45271Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 6.4527C4 5.09812 5.09812 4 6.4527 4H9.12838C10.483 4 11.5811 5.09812 11.5811 6.4527C11.5811 7.80729 10.483 8.90541 9.12838 8.90541H6.4527C5.09812 8.90541 4 7.80729 4 6.4527ZM6.4527 5.33784C5.83698 5.33784 5.33784 5.83698 5.33784 6.4527C5.33784 7.06843 5.83698 7.56757 6.4527 7.56757H9.12838C9.74411 7.56757 10.2432 7.06843 10.2432 6.4527C10.2432 5.83698 9.74411 5.33784 9.12838 5.33784H6.4527Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M4.66893 13.1419C4.66893 11.9104 5.66722 10.9121 6.89866 10.9121H8.68245C9.91389 10.9121 10.9122 11.9104 10.9122 13.1419V17.6013C10.9122 18.8328 9.91389 19.8311 8.68245 19.8311H6.89866C5.66722 19.8311 4.66893 18.8328 4.66893 17.6013V13.1419Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 13.1419C4 11.5411 5.29777 10.2433 6.89865 10.2433H8.68243C10.2833 10.2433 11.5811 11.5411 11.5811 13.1419V17.6014C11.5811 19.2022 10.2833 20.5 8.68243 20.5H6.89865C5.29777 20.5 4 19.2022 4 17.6014V13.1419ZM6.89865 11.5811C6.03664 11.5811 5.33784 12.2799 5.33784 13.1419V17.6014C5.33784 18.4634 6.03664 19.1622 6.89865 19.1622H8.68243C9.54445 19.1622 10.2432 18.4634 10.2432 17.6014V13.1419C10.2432 12.2799 9.54445 11.5811 8.68243 11.5811H6.89865Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M13.5878 6.89866C13.5878 5.66722 14.5861 4.66893 15.8176 4.66893H17.6013C18.8328 4.66893 19.8311 5.66722 19.8311 6.89866V11.3581C19.8311 12.5896 18.8328 13.5878 17.6013 13.5878H15.8176C14.5861 13.5878 13.5878 12.5896 13.5878 11.3581V6.89866Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9189 6.89865C12.9189 5.29777 14.2167 4 15.8176 4H17.6014C19.2022 4 20.5 5.29777 20.5 6.89865V11.3581C20.5 12.959 19.2022 14.2568 17.6014 14.2568H15.8176C14.2167 14.2568 12.9189 12.959 12.9189 11.3581V6.89865ZM15.8176 5.33784C14.9556 5.33784 14.2568 6.03664 14.2568 6.89865V11.3581C14.2568 12.2201 14.9556 12.9189 15.8176 12.9189H17.6014C18.4634 12.9189 19.1622 12.2201 19.1622 11.3581V6.89865C19.1622 6.03664 18.4634 5.33784 17.6014 5.33784H15.8176Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M13.5878 18.0473C13.5878 17.0621 14.3864 16.2635 15.3716 16.2635H18.0473C19.0325 16.2635 19.8311 17.0621 19.8311 18.0473C19.8311 19.0325 19.0325 19.8311 18.0473 19.8311H15.3716C14.3864 19.8311 13.5878 19.0325 13.5878 18.0473Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9189 18.0473C12.9189 16.6927 14.017 15.5946 15.3716 15.5946H18.0473C19.4019 15.5946 20.5 16.6927 20.5 18.0473C20.5 19.4019 19.4019 20.5 18.0473 20.5H15.3716C14.017 20.5 12.9189 19.4019 12.9189 18.0473ZM15.3716 16.9324C14.7559 16.9324 14.2568 17.4315 14.2568 18.0473C14.2568 18.6631 14.7559 19.1622 15.3716 19.1622H18.0473C18.6631 19.1622 19.1622 18.6631 19.1622 18.0473C19.1622 17.4315 18.6631 16.9324 18.0473 16.9324H15.3716Z"
      :fill="
        currentScreen === tabRoutes.DASHBOARD
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
  </svg>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';

import {tabRoutes} from '@/routes';

const store = useStore();

const currentScreen = computed(() => store.getters['tab/screen']);
</script>
